module.exports = "https://www.gc-pro.gnp.com.mx/da5197f9cef3e2add98d27d6c23aa376.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/circle-pago.svg
// module id = 1806
// module chunks = 0